export default "__VITE_ASSET__DGI55sal__"